module.exports = __webpack_public_path__ + "static/hip_pos_traj-c0dfc91586f09278bae2341480dcb28f.png";